import { useEffect, useRef, useState } from 'react';
import './Counter.css';

/* ============================================================================
   Counter — a big readout that physically reacts when its value changes.

   The bump is driven by a key that changes on every value change rather than
   by toggling a class, so a rapid sequence of guesses restarts the animation
   cleanly instead of the browser ignoring a re-added class.
   ========================================================================== */

function Counter({
  value,
  label,
  tone = 'red',
  size = 'md', // sm | md | lg
  className = '',
  ...rest
}) {
  const [bump, setBump] = useState(0);
  const previous = useRef(value);

  useEffect(() => {
    if (previous.current !== value) {
      previous.current = value;
      setBump((n) => n + 1);
    }
  }, [value]);

  return (
    <div className={`ui-counter ui-counter--${tone} ui-counter--${size} ${className}`} {...rest}>
      <span key={bump} className="ui-counter__value">
        {value}
      </span>
      {label && <span className="ui-counter__label">{label}</span>}
    </div>
  );
}

export default Counter;
